import { normalize, schema } from 'normalizr';
import { fetchAction, SingleSocketFactory } from 'barnyard/utils';
import * as constants from './constants';
import { renderSnackbarAlerts, removeSnackbarAlerts } from './utils';

const alert = new schema.Entity('alerts');

export const dismissAlert = alertId => dispatch => fetchAction(
  dispatch,
  constants.ALERT_DISMISS,
  { alertId },
  {
    url: `/api/alerts/${alertId}/`,
    method: 'PATCH'
  }
);

const alertDismissAction = dispatch => alertId => dispatch(dismissAlert(alertId));

export const fetchAlerts = (url = '/api/alerts/') => dispatch => fetchAction(
  dispatch,
  constants.ALERTS_FETCH,
  { },
  {
    url,
    success: (result) => {
      const normalized = normalize(result, [alert]);
      dispatch({
        type: constants.ALERTS_FETCH.success,
        entities: normalized.entities,
        ids: normalized.result
      });
      renderSnackbarAlerts(result, alertDismissAction(dispatch));
    }
  }
);

export const fetchAlertsCorporate = () => fetchAlerts('/api/alerts/corporate/');

const alertAddDispatch = (dispatch, alrt) => {
  dispatch({
    type: constants.NEW_ALERT,
    result: alrt,
    alertId: alrt.id
  });
  renderSnackbarAlerts([alrt], alertDismissAction(dispatch));
};

const alertRemoveDispatch = (dispatch, alrt) => {
  dispatch({
    type: constants.REMOVE_ALERT,
    alertId: alrt.id
  });
  removeSnackbarAlerts([alrt]);
};

const onMessageReceive = dispatch => (message) => {
  switch (message.action) {
    case constants.NEW_ALERT:
      alertAddDispatch(dispatch, message);
      break;
    case constants.REMOVE_ALERT:
      alertRemoveDispatch(dispatch, message);
      break;
    default:
      break;
  }
};

export const registerAlertsSubscription = (dispatch, getState, isBuyer = true) => {
  const socketStream = SingleSocketFactory.getInstance(constants.ALERTS_EVENT_TYPE);
  const alertsFetcher = isBuyer ? fetchAlerts : fetchAlertsCorporate;

  if (!socketStream.isRegistered) {
    dispatch(alertsFetcher());
    socketStream.register({
      onMessage: onMessageReceive(dispatch, getState),
      onMessageError: () => {},
      onReconnect: alertsFetcher,
      onError: () => {}
    });
  }

  return socketStream;
};
